"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const util_1 = require("../../../util");
function Grid(props) {
    const xProps = { ...props };
    const { children } = props;
    const nC = [];
    const divProps = {};
    const keys = Object.keys(xProps);
    for (const key of keys) {
        if (key) {
            const val = xProps[key];
            switch (key) {
                // CUSTOM CASES
                case 'className':
                    if (Array.isArray(val)) {
                        nC.push(...val);
                    }
                    else {
                        nC.push(val);
                    }
                    break;
                case 'divRef':
                    divProps.ref = val;
                    break;
                case 'flexStart':
                    if (val)
                        nC.push('glx-flex-start');
                    break;
                case 'layOut':
                    if (val)
                        nC.push(`glx-layout-${val}`);
                    break;
                case 'fullWidth':
                    if (val)
                        nC.push('glx-w-full');
                    break;
                case 'flexMobile':
                    if (val)
                        nC.push('glx-mobile-wrap');
                    break;
                case 'flexEnd':
                    if (val)
                        nC.push('glx-flex-end');
                    break;
                case 'flexSpaceA':
                    if (val)
                        nC.push('glx-flex-space-around');
                    break;
                case 'flexSpaceB':
                    if (val)
                        nC.push('glx-flex-space-between');
                    break;
                case 'gap':
                    if (val)
                        nC.push(`glx-flex-g-${val}`);
                    break;
                case 'grow':
                    if (val)
                        nC.push(`glx-flex-grow-${val}`);
                    break;
                case 'center':
                    if (val)
                        nC.push('glx-flex-center');
                    break;
                case 'vCenter':
                    if (val)
                        nC.push('glx-flex-v-center');
                    break;
                case 'hCenter':
                    if (val)
                        nC.push('glx-flex-h-center');
                    break;
                case 'flex':
                    if (val)
                        nC.push('glx-flex');
                    break;
                case 'flexRow':
                    if (val)
                        nC.push('glx-flex-row');
                    break;
                case 'flexR':
                    if (val)
                        nC.push('glx-flex-r');
                    break;
                case 'flexColumn':
                    if (val)
                        nC.push('glx-flex-column');
                    break;
                case 'flexC':
                    if (val)
                        nC.push('glx-flex-c');
                    break;
                // EMPTY CASES
                case 'children':
                case undefined:
                case null:
                    break;
                // Default CASES
                default:
                    divProps[key] = val;
                    break;
            }
        }
    }
    if (nC.length > 0) {
        divProps.className = (0, util_1.cnx)(...nC);
    }
    // eslint-disable-next-line react/jsx-props-no-spreading
    return react_1.default.createElement("div", { ...divProps }, children);
}
exports.default = Grid;
Grid.defaultProps = {
    className: undefined,
    flex: undefined,
    flexRow: undefined,
    flexR: undefined,
    flexColumn: undefined,
    flexC: undefined,
    divRef: undefined,
    center: undefined,
    vCenter: undefined,
    hCenter: undefined,
    gap: undefined,
    grow: undefined,
    flexStart: undefined,
    flexEnd: undefined,
    flexSpaceA: undefined,
    flexSpaceB: undefined,
    fullWidth: undefined,
    layOut: undefined,
    flexMobile: undefined,
};
